/**
 * UI类型枚举
 */
export type UIType = 'A' | 'B' | 'C' | 'D' | 'E';

export const CHANNEL_TYPE_MAP = {
    w2a: 'w2a',
    h5ocr: 'h5ocr'
};

/**
 * 链路类型枚举
 */
export type ChannelType = 'w2a' | 'h5ocr';

/**
 * UI类型列表
 */
export const UI_TYPES: UIType[] = ['A', 'B', 'C', 'D', 'E'];

/**
 * 链路类型列表
 */
export const CHANNEL_TYPES: ChannelType[] = Object.values(
    CHANNEL_TYPE_MAP
) as ChannelType[];

/**
 * 分组类型参数名
 */
export const GROUP_TYPE_PARAM = 'group_type';

/**
 * 默认UI类型
 */
export const DEFAULT_UI_TYPE: UIType = 'A';

/**
 * 默认链路类型
 */
export const DEFAULT_CHANNEL_TYPE: ChannelType = 'w2a';

/**
 * 获取组合参数中的具体值
 * @param paramName 参数名
 * @param defaultValue 默认值
 * @returns 参数值
 */
export const getCombinedParam = (
    paramName: string,
    defaultValue: string = ''
): string => {
    const urlParams = new URLSearchParams(window.location.search);
    const value = urlParams.get(paramName) || defaultValue;

    return value;
};

/**
 * 从组合参数中获取UI类型
 * @param paramName 参数名
 * @param enums 允许的UI类型枚举
 * @param defaultValue 默认值
 * @returns UI类型
 */
export const getParamsUI = (
    paramName: string,
    enums: UIType[],
    defaultValue: UIType = 'A'
): UIType => {
    const value = getCombinedParam(paramName, defaultValue);
    const parts = value.split(',');

    // 遍历所有部分，查找匹配的UI类型
    for (const part of parts) {
        if (enums.includes(part as UIType)) {
            return part as UIType;
        }
    }

    return defaultValue;
};

/**
 * 从组合参数中获取链路类型
 * @param paramName 参数名
 * @param enums 允许的链路类型枚举
 * @param defaultValue 默认值
 * @returns 链路类型
 */
export const getParamsChannel = (
    paramName: string,
    enums: ChannelType[],
    defaultValue: ChannelType = 'w2a'
): ChannelType => {
    const value = getCombinedParam(paramName, defaultValue);
    const parts = value.split(',');

    // 遍历所有部分，查找匹配的链路类型
    for (const part of parts) {
        if (enums.includes(part as ChannelType)) {
            return part as ChannelType;
        }
    }

    return defaultValue;
};

/**
 * 构建组合参数
 * @param type UI类型
 * @param channel 链路类型
 * @returns 组合后的参数值
 */
export const buildCombinedParam = (
    type: UIType,
    channel: ChannelType
): string => {
    return `${type}${channel ? ',' + channel : ''}`;
};
